<template>
  <div class="timebox">
    <el-form label-position="right" label-width="100px">
      <el-form-item label="工作日：">
        <el-checkbox-group v-model="checkin_date.work_days">
          <el-checkbox v-for="(day, index) in daysOfWeek" :key="index" :label="day.value" :disabled="isDayDisabled(day.value)">{{ day.label }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="打卡时间：">
        <div style="margin-bottom: 10px" v-for="(item, index) in checkin_date.checkin_time" :key="index">
          <span class="gowork">上班</span>
          <el-time-select
            placeholder="上班时间"
            v-model="item.work_sec"
            :picker-options="{
              start: checkin_date.checkin_time[index - 1] ? checkin_date.checkin_time[index - 1].off_work_sec : '00:00',
              step: '00:15',
              end: '23:00'
            }"
          />
          <span> — </span>
          <span class="gowork">下班</span>
          <el-time-select class="timeselect" placeholder="下班时间" v-model="item.off_work_sec" :picker-options="{ start: '00:00', step: '00:15', end: '23:00', minTime: item.work_sec }" />
          <i class="el-icon-remove" style="margin-right: 5px" v-show="checkin_date.checkin_time.length >= 2" @click="deleteClock(index)"></i>
          <i class="el-icon-circle-plus" v-show="index === checkin_date.checkin_time.length - 1" :class="{ disabled: checkin_date.checkin_time.length >= 2 }" @click="copyClock"></i>
        </div>
      </el-form-item>
      <el-form-item label="" style="height: 10px">
        <el-button type="primary" @click="confirmbtn" class="btn-container">确认</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    FuallWorkDays: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      checkin_date: {
        work_days: [],
        checkin_time: [{ work_sec: '', off_work_sec: '' }]
      },
      isEdit: false,
      daysOfWeek: [
        { value: 1, label: '星期一' },
        { value: 2, label: '星期二' },
        { value: 3, label: '星期三' },
        { value: 4, label: '星期四' },
        { value: 5, label: '星期五' },
        { value: 6, label: '星期六' },
        { value: 0, label: '星期日' }
      ]
    }
  },
  computed: {},
  methods: {
    async send(rowData, isEdit) {
      this.checkin_date = rowData
      this.isEdit = isEdit
    },

    isDayDisabled(value) {
      return this.FuallWorkDays?.includes(value)
    },

    // 多加一个上下班时间
    copyClock() {
      this.checkin_date.checkin_time.push({ work_sec: '', off_work_sec: '' })
    },
    // 删去一个上下班时间
    deleteClock(index) {
      this.checkin_date.checkin_time.splice(index, 1)
    },
    confirmbtn() {
      if (!this.checkin_date.work_days.length) {
        this.$message({
          message: '请选择工作日',
          type: 'error'
        })
        return
      }

      // 检查上下班时间是否已填写
      const allTimesFilled = this.checkin_date.checkin_time.every(item => item.work_sec && item.off_work_sec)
      if (!allTimesFilled) {
        this.$message({
          message: '请选择上下班时间',
          type: 'error'
        })
        return
      }

      // 检查上下班时间大小
      const invalidTimes = this.checkin_date.checkin_time.some(item => item.off_work_sec < item.work_sec)
      if (invalidTimes) {
        this.$message({
          message: '下班时间不能小于上班时间',
          type: 'error'
        })
        return
      }

      // 检查时间段顺序（前一个时间段的下班时间不能大于下一个时间段的上班时间）
      const invalidOrder = this.checkin_date.checkin_time.some((item, index, array) => {
        if (index === array.length - 1) return false // 最后一项没有下一个项可比对
        return item.off_work_sec > array[index + 1].work_sec
      })
      if (invalidOrder) {
        this.$message({
          message: '前一个时间段的下班时间不能大于下一个时间段的上班时间',
          type: 'error'
        })
        return
      }

      this.$emit('updata', this.checkin_date, this.isEdit)
    }
  }
}
</script>

<style>
.gowork {
  margin-right: 10px;
}
.timebox {
  min-height: 250px;
}
.timeselect {
  margin-right: 10px;
}
.disabled {
  opacity: 0.6; /* 降低透明度来模拟禁用效果 */
  cursor: not-allowed; /* 改变鼠标指针为不可用状态 */
  pointer-events: none; /* 阻止点击事件 */
}
.btn-container {
  float: right;
}
</style>